const version = "v2";

export const endPoints = {

  DASHBOARD : `/${version}/admin/dashboard`,

  AUTH_LOGIN: `/${version}/auth/login`,
  GET_SLIDERS: `/${version}/admin/slider`,
  ADD_SLIDER: `/${version}/admin/slider/add`,
  UPDATE_SLIDER: `/${version}/admin/slider/update`,
  DELETE_SLIDER: `/${version}/admin/slider/delete`,
  STATUS_SLIDER: `/${version}/admin/slider/status`,
  
  /////////// services ////////////

  GET_SERVICE_TYPES: `/${version}/admin/service-type`,
  ADD_SERVICE_TYPE: `/${version}/admin/service-type/add`,
  UPDATE_SERVICE_TYPE: `/${version}/admin/service-type/update`,
  STATUS_SERVICE_TYPE: `/${version}/admin/service-type/status`,
  DELETE_SERVICE_TYPE: `/${version}/admin/service-type/delete`,

  GET_SERVICES: `/${version}/admin/service`,
  ADD_SERVICE: `/${version}/admin/service/add`,
  UPDATE_SERVICE: `/${version}/admin/service/update`,
  STATUS_SERVICE: `/${version}/admin/service/status`,
  DELETE_SERVICE: `/${version}/admin/service/delete`,

  ////////// category ///////

  GET_CATEGORIES: `/${version}/admin/category`,
  ADD_CATEGORY: `/${version}/admin/category/add`,
  UPDATE_CATEGORY: `/${version}/admin/category/update`,
  STATUS_CATEGORY: `/${version}/admin/category/status`,
  DELETE_CATEGORY: `/${version}/admin/category/delete`,
  GET_SUB_CATEGORIES: `/${version}/admin/category/sub-category`,
  SEQUENCE_CATEGORY : `/${version}/admin/category/sequence`,

  ///////// orders management ///////////

  GET_ORDER_STATUSES : `/${version}/admin/orders/statuses`,
  GET_ORDERS : `/${version}/admin/orders`,
  GET_SINGLE_ORDER : `/${version}/admin/orders`,
  CHANGE_ORDER_STATUS : `/${version}/admin/orders/change-status`,
  SEND_DRIVER_REMINDER : `/${version}/admin/orders/reminder-notification`,

  /////////// custome forms ///////////

  GET_FORMS : `${version}/admin/forms`,
  ADD_FORM : `${version}/admin/forms/add`,
  UPDATE_FORM : `${version}/admin/forms/update`,
  DELETE_FORM : `${version}/admin/forms/delete`,
  GET_SINGLE : `${version}/admin/forms`,
  STATUS_FORM : `${version}/admin/forms/status`,

  ///////// driver managements ///////

  GET_VEHICLES : `${version}/admin/driver/vehicle`,
  STATUS_VEHICLE : `${version}/admin/driver/vehicle/status-change`,
  GET_DRIVERS : `${version}/admin/driver`,
  GET_SINGLE_DRIVER : `${version}/admin/driver/get-one`,
  GET_DRIVERS_ORDERS : `/${version}/admin/driver/orders`,
  GET_DRIVER_PAYOUT :`/${version}/admin/wallet/driver-payouts`,
  UPDATE_DRIVER_PAYOUT_STATUS :`/${version}/admin/wallet/payout-status-change`,
  GET_DRIVER_PAYOUT_STATUSES :`/${version}/admin/wallet/payout-statuses`,
  GET_DRIVER_SETTLEMENT      :`/${version}/admin/wallet/driver-settlements`,

  

  ////// tutorial //////

  GET_TUTERIALS : `/${version}/admin/page/get-video`,
  UPDATE_TUTORIAL : `/${version}/admin/page/update-video`,
  ADD_TUTORIAL : `/${version}/admin/page/add-video`,
  DELETE_TUTORIAL : `/${version}/admin/page/delete-video`,

  /// news ///

  GET_NEWS : `/${version}/admin/page/news`,
  UPDATE_NEWS : `/${version}/admin/page/update-news`,
  ADD_NEWS : `/${version}/admin/page/add-news`,
  DELETE_NEWS : `/${version}/admin/page/delete-news`,

  ///////// pages privacy policy terms and conditions ///////
  
  GET_PAGES : `/${version}/admin/page/get-pages`,
  UPDATE_PAGE : `/${version}/admin/page/update-page`,

  //////// faqs //////////

  GET_FAQS : `/${version}/admin/page/get-faq`,
  ADD_FAQ : `/${version}/admin/page/add-faq`,
  UPDATE_FAQ : `/${version}/admin/page/update-faq`,
  DELETE_FAQ : `/${version}/admin/page/delete-faq`,
  SEQUENCE_FAQ : `/${version}/admin/page/update-faq-sequence`,

  //////////// onboarding screen //////////////

  GET_ONBOARDING : `/${version}/admin/onboarding`,
  ADD_ONBOARDING : `/${version}/admin/onboarding/add`,
  UPDATE_ONBOARDING : `/${version}/admin/onboarding/update`,
  DELETE_ONBOARDING : `/${version}/admin/onboarding/delete`,
  STATUS_ONBOARDING : `/${version}/admin/onboarding/status`,

  ////////// notifications ////////////

  GET_NOTIFICATIONS : `/${version}/admin/notification`,
  GET_TOPICS : `/${version}/admin/notification/get-topics`,
  ADD_NOTIFICATION : `/${version}/admin/notification/create`,
  TRY_NOTIFICATION : `/${version}/admin/notification/try-again`,
  // UPDATE_NOTIFICATION : `/${version}/admin/notifications/update`,
  // DELETE_NOTIFICATION : `/${version}/admin/notifications/delete`,
  // STATUS_NOTIFICATION : `/${version}/admin/notifications/status`,
 
  
 //////////// customers //////////////
 
  GET_CUSTOMERS : `/${version}/admin/customers/list`,
  GET_SINGLE_CUSTOMER : `/${version}/admin/customers/details`,
  GET_CUSTOMER_ORDERS : `/${version}/admin/customers/orders`,

  /////////// wallet routes //////////

  GET_COA : `/${version}/admin/wallet/coas`,
  CREATE_OR_ADD_AMOUNT : `/${version}/admin/wallet/create-or-update`,
  GET_WALLET_BY_USER_ID : `/${version}/admin/wallet/get-one`,
  GET_TRANSACTIONS_BY_WALLET_ID : `/${version}/admin/wallet/transactions`,


  ////////// Admin routes /////////////
  GET_ADMIN_SETTINGS : `/${version}/admin/setting`,
  UPDATE_ADMIN_SETTINGS : `/${version}/admin/setting/update`,

};
